// SINGLE SOURCE OF TRUTH for upcoming PopCrown / featured-member events.
// The Events page renders cards from this list.
// The Home page countdown clock targets the soonest future event in this list.
// When an event's date passes it automatically drops off the home page
// and the next upcoming event becomes the countdown target.
//
// To add a new event: append an object below with a future `startDate` (ISO 8601).
// To retire an event: delete it OR let its date pass (it'll auto-hide on Home).

export const UPCOMING_EVENTS = [
  {
    id: 'mjexp-rhinestone-glove-sep-2026',
    title: 'Rhinestone Glove Workshop',
    organiser: 'The MJ Experience',
    organiserUrl: 'https://www.themjexperience.co.uk/',
    city: 'London',
    venueNote: 'Bring your own booze',
    startDate: '2026-09-05T19:00:00+01:00',
    displayDate: 'Saturday 5 September 2026',
    categoryLabel: 'Workshop',
    categoryColor: 'gold',
    description:
      'Make the most iconic glove in pop history with your own two hands. Rhinestones, glue, music, and one of the most fan-coveted MJ tributes you can build.',
    image: '/event-mjexp-rhinestone-glove.jpg',
    imageAlt:
      'The MJ Experience Rhinestone Glove Workshop Michael Jackson hands-on craft London Saturday 5 September 2026',
    bookingUrl:
      'https://www.designmynight.com/london/whats-on/activity/michael-jackson-rhinestone-glove-workshop-1?t=tickets',
    testIdSuffix: 'sep5',
  },
  {
    id: 'mjexp-sip-paint-aug-2026',
    title: 'Sketched Sip & Paint — MJ Birthday Celebration',
    organiser: 'The MJ Experience',
    organiserUrl: 'https://www.themjexperience.co.uk/',
    city: 'London',
    venueNote: 'The Eastside Creative, 20 Market Square, All Saints, London E14 6AQ · Bring your own booze',
    startDate: '2026-08-30T17:00:00+01:00',
    displayDate: 'Sunday 30 August 2026 · 5pm – 8pm',
    categoryLabel: 'Sip & Paint',
    categoryColor: 'red',
    description:
      "Celebrating the King of Pop's birthday. An immersive MJ Sketched Sip & Paint experience with DJ Cli, MJ Bingo, dance-offs, karaoke, best-dressed prizes, MJ props and a content corner. Choose from 3 sketched canvases (or go blank), from £27.50 Early Bird up to £33. Kids aged 10+ welcome (£16.50). Just here for the vibes and games? Grab the no-canvas ticket for £11.",
    image: '/event-mjexp-glove-and-smile.jpg',
    imageAlt:
      'The MJ Experience Sketched Sip and Paint Michael Jackson Glove and Smile birthday celebration London Sunday 30 August 2026',
    bookingUrl:
      'https://www.designmynight.com/london/whats-on/activity/michael-jackson-sketched-sip-paint-1?t=tickets',
    testIdSuffix: 'aug30',
  },
  {
    id: 'mjexp-sip-paint-thriller-nov-2026',
    title: 'Sketched Sip & Paint — Thriller Theme with KAT B',
    organiser: 'The MJ Experience',
    organiserUrl: 'https://www.themjexperience.co.uk/',
    city: 'London',
    venueNote: 'The Eastside Creative, All Saints, London E14 · Bring your own booze',
    startDate: '2026-11-01T17:00:00+00:00',
    displayDate: 'Sunday 1 November 2026 · 5pm – 9pm',
    categoryLabel: 'Thriller Special',
    categoryColor: 'red',
    description:
      "Full-on THRILLER theme, hosted by comedian KAT B. Thriller dance class from 5pm–6pm, then the art party kicks in — sketch and paint your MJ canvas with DJ Cli spinning MJ classics. Choose from 4 sketched canvases (Bad, Thriller, With Glove, Glove & Smile with rhinestones), from £27.50 Early Bird up to £38.50. Kids aged 10+ welcome (£16.50). Just here for the vibes? £11 gets you in for the MJ Bingo, dance-offs, sing-a-longs and games (no canvas). Thriller dance class only — £11.",
    image: '/event-mjexp-glove-and-smile.jpg',
    imageAlt:
      'The MJ Experience Sketched Sip and Paint Thriller theme hosted by KAT B London Sunday 1 November 2026',
    bookingUrl:
      'https://www.designmynight.com/london/whats-on/activity/michael-jackson-sketched-sip-paint-3?t=tickets',
    testIdSuffix: 'nov1',
  },
  {
    id: 'kingvention-dangerous-the-party-nov-2026',
    title: 'DANGEROUS: The Party — 35th Anniversary',
    organiser: 'Kingvention',
    organiserUrl: 'https://www.kingvention.com/',
    city: 'London',
    venueNote: 'Notting Hill Arts Club, 21 Notting Hill Gate, London W11 3JQ · 18+ (13–17 with prior approval via info@kingvention.com)',
    startDate: '2026-11-14T19:30:00+00:00',
    displayDate: 'Saturday 14 November 2026 · 7:30pm – 2am',
    categoryLabel: 'Kingvention',
    categoryColor: 'red',
    description:
      "Celebrating 35 years of Dangerous at the legendary Notting Hill Arts Club — the venue that has hosted Amy Winehouse, Ed Sheeran and Bruno Mars, and welcomed Beyoncé and Jay-Z. DJ Wiz spinning the biggest hits from Dangerous plus fan favourites and deep cuts. Special Michael Jackson-themed cocktails (Black or White, JAM, Dangerous — from £13). Over 50% of tickets already gone. Early Bird tickets available 14–27 July 2026. PopCrown members get exclusive access to the Early Bird Bundle (party ticket + official T-shirt) — sign up free or paid to receive your member code. Full-price tickets go live 28 July. 18+ venue. No door sales.",
    image: '/event-kingvention-dangerous.jpg',
    imageAlt:
      'Kingvention DANGEROUS The Party Michael Jackson Dangerous album 35th anniversary Notting Hill Arts Club London Saturday 14 November 2026',
    bookingUrl: 'https://kingvention.simpletix.com/',
    testIdSuffix: 'nov14',
  },
];

/**
 * Returns events whose startDate is in the future, sorted soonest-first.
 * Re-evaluates on every call so it stays accurate as time passes.
 */
export const getUpcomingEvents = (now = Date.now()) =>
  UPCOMING_EVENTS
    .filter((e) => new Date(e.startDate).getTime() > now)
    .sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    );

/**
 * Returns the single soonest upcoming event (or null if none scheduled).
 * Used by the Home page hero countdown clock.
 */
export const getNextEvent = (now = Date.now()) => {
  const upcoming = getUpcomingEvents(now);
  return upcoming.length > 0 ? upcoming[0] : null;
};
